<app-fixed-content-page
  [content]="content"
  [action]="action"
/>

<ng-template #content>
  <h1 class="text-bold m-b-5 m-t-5">Assessment instructions</h1>

  <div class="content-layout-column-sm-row-lg">
    <div>
      <!-- NOTE: To be refactored -->
      <div class="tip-container rounded-16 overflow-hidden">
        <div class="tip-header d-flex align-items-center p-3">
          <div class="bg-white rounded-circle p-2 m-2">
            <svg-icon
              src="assets/icons/tips-bulb.svg"
              [svgStyle]="{ 'width.px': 22 }"
            >
            </svg-icon>
          </div>
          <h4 class="text-white font-size-18 fw-bold m-1 p-r-1">Tips to improve your assessment experience</h4>
        </div>
        <div class="p-3 p-lg-4">
          <ul class="pt-1 ps-3">
            <li class="pb-4">Find a quiet environment, free of interruptions or distractions.</li>
            <li class="pb-3">Make sure you read the instructions at the start of each game.</li>
            <li class="pb-3">Make sure you complete the assessment in full.</li>
          </ul>

          <app-callout trackingId="assessment-instructions-callout">
            <div class="callout-content">
              <div>
                <svg-icon
                  class="m-r-1"
                  src="assets/icons/clock.svg"
                  [svgStyle]="{ 'width.px': 18, 'height.px': 26 }"
                />

                <strong>15-30</strong> minutes
              </div>

              <div>
                <svg-icon
                  class="m-r-1"
                  src="assets/icons/lesson.svg"
                  [svgStyle]="{ 'width.px': 18, 'height.px': 26 }"
                />

                <strong>8</strong> test categories
              </div>
            </div>
          </app-callout>
        </div>
      </div>
    </div>

    <div class="pt-5">
      <svg-icon
        role="img"
        src="assets/images/report-group.svg"
        [svgStyle]="{ width: '100%' }"
      >
      </svg-icon>
    </div>
  </div>
</ng-template>

<ng-template #action>
  <div class="action-button-block-sm-end-md">
    <app-button
      trackingId="assessment-start"
      (clicked)="navigateToOverview()"
    >
      Continue
    </app-button>
  </div>
</ng-template>
